import { tutorBookingDetailsPath } from './tutorBookingDetailsPath';

export function httpStatusFromUnknown(error: unknown): number | null {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return typeof status === 'number' ? status : null;
}

/**
 * Tutor SMS links `/tutor/bookings?bookingId=` belong to that lesson's tutor.
 * A school host with TUTOR role still opens the tutor inbox (empty). Send them
 * to host lesson details when the booking is theirs as host, not as tutor.
 */
export function tutorSmsLandingPath(
  bookingId: string,
  tutorLookupHttpStatus: number | null,
  hostLookupHttpStatus: number | null,
): string | null {
  const id = bookingId.trim();
  if (!id) return null;
  if (tutorLookupHttpStatus === 200) return null;
  if (hostLookupHttpStatus === 200) {
    return tutorBookingDetailsPath('host', id);
  }
  return null;
}
